'use-client';
import * as React from 'react';
import type { SvgImageProps } from '../../../SvgImage.types';
import { SvgImageBase } from '../../SvgImage';

export const getMaskId = (id: string) => `svg-mask-${id}`;
export const getMaskBgId = (id: string) => `svg-mask-bg-${id}`;

const extractStartCoordinatesFromViewbox = (viewBox = '0 0 0 0') => {
  const [x, y] = viewBox.split(' ');

  return { x, y };
};

function SvgImageTintSkin(props: SvgImageProps) {
  const { id, viewBox, svgString } = props;

  const startCoordinates = extractStartCoordinatesFromViewbox(viewBox);

  return (
    <SvgImageBase {...props}>
      <defs>
        <mask id={getMaskBgId(id)} mask-type="alpha">
          <g dangerouslySetInnerHTML={{ __html: svgString }} />
        </mask>
        <mask id={getMaskId(id)} mask-type="luminance">
          <g
            dangerouslySetInnerHTML={{ __html: svgString }}
            filter={`url(#invert-${id})`}
          />
        </mask>
        {/* Optimization: this part will be moved to be global so it can be reused */}
        <filter id={`invert-${id}`} color-interpolation-filters="sRGB">
          <feComponentTransfer>
            <feFuncR type="table" tableValues="1 0" />
            <feFuncG type="table" tableValues="1 0" />
            <feFuncB type="table" tableValues="1 0" />
          </feComponentTransfer>
        </filter>
      </defs>
      <rect
        fill="white"
        width="100%"
        height="100%"
        x={startCoordinates.x}
        y={startCoordinates.y}
        mask={`url(#${getMaskBgId(id)})`}
      />
      <rect
        fill="var(--svg-color-1)"
        width="100%"
        height="100%"
        x={startCoordinates.x}
        y={startCoordinates.y}
        mask={`url(#${getMaskId(id)})`}
      />
    </SvgImageBase>
  );
}

export default SvgImageTintSkin;
